export default __webpack_public_path__ + "static/media/Vectors.17ca9d68.png";